export const InsurancesEndpoint = (makeRequest) => {
    return {
        create(params, options) {
            return makeRequest('POST', '/v3/billing/insurances', params, options);
        },
        // Opens a support request because the patient had trouble applying a coupon by themselves
        notifyOps(params, options) {
            return makeRequest('POST', '/v3/billing/insurances/notify_ops', params, options);
        },
        // Bills the provided coupon-based insurance and applies it to the delivery
        applyCoupon(params, options) {
            return makeRequest('POST', '/v3/billing/insurances/apply_coupon', params, options);
        },
        // Creates a billable insurance from a coupon
        createCopayCard(params, options) {
            return makeRequest('POST', '/v3/billing/insurances/copay_card', params, options);
        },
    };
};
//# sourceMappingURL=insurances_endpoint.js.map